<template>
    <td class="clickable keyword-movement" v-tooltip.top="$t('labels.ranked', { date: rankedDate })">
        <span class="d-flex justify-content-between align-items-center">
            <span>
                <span v-if="local" class="pr-1">{{ local }}<small>GM</small>,</span>
                <span>{{ natural }}</span>
                <span>{{ natural2 }}</span>
            </span>
            <small class="d-flex flex-column align-items-center" v-if="movement !== 0" :class="movement < 0 ? 'text-danger' : 'text-success'">
                <fa-icon v-if="movement > 0" :icon="['fas', 'caret-up']" />
                <span>{{ movement }}</span>
                <fa-icon v-if="movement < 0" :icon="['fas', 'caret-down']" />
            </small>
        </span>
    </td>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'KeywordMovement',
  props: ['data', 'index'],
  computed: {
    natural () {
      if (!this.data[this.index]) return 'No Data'
      return this.data[this.index].natural ? this.data[this.index].natural.position : null
    },
    natural2 () {
      return this.data[this.index] && this.data[this.index].natural_2 ? this.data[this.index].natural_2.position : null
    },
    local () {
      return this.data[this.index] && this.data[this.index].local ? this.data[this.index].local.position : null
    },
    rankedDate () {
      return this.data[this.index] && this.data[this.index].natural ? DateTime.fromISO(this.data[this.index].natural.created_at).toLocaleString(DateTime.DATE_MED) : ''
    },
    movement () {
      if (!this.data[this.index]) return null
      const current = this.data[this.index] && this.data[this.index].natural ? this.data[this.index].natural.position : 100
      const previous = this.data[this.index - 1] && this.data[this.index - 1].natural ? this.data[this.index - 1].natural.position : 100
      return previous - current
    }
  }
}
</script>

<style lang="scss">
    .keyword-movement {
        min-width: 90px;
    }
</style>
